import {all, takeLatest} from "redux-saga/lib/effects"
import {LOCATION_CHANGED} from "redux-little-router"

// types
import {StartupTypes} from "./containers/App/startup.redux"
import {AppTypes} from "./containers/App/redux"
import {LoginTypes} from "./containers/Login/redux"
import {CommentsTypes} from "./containers/Comments/redux"
import {NotificationsTypes} from "./containers/Notifications/redux"

import {ManageBookmarksTypes} from "./containers/ManageBookmarks/redux"
import {ManageLikesTypes} from "./containers/ManageLikes/redux"

import {LearningModulesTypes} from "./containers/LearningModules/redux"

// sagas (independent of router changes)
import startup, {startupLocation} from "./containers/App/startup.sagas"
import fetchMenus, {
  addTracking,
  changeDocumentTitle,
  shouldChangeDocumentTitle,
  forceLogout,
  fetchNotifications,
  readNotification as readNotificationApp,
  readAllNotifications as readAllNotificationsApp
} from "./containers/App/sagas"
import router from "./containers/Router/sagas"
import comments, {add as addCommentSaga} from "./containers/Comments/sagas"
import {checkForLoginCookie} from "./containers/Logout/sagas"
import {read as readNotification} from "./containers/Notifications/sagas"

import {addBookmark} from "./containers/ManageBookmarks/sagas"
import {removeBookmark} from "./containers/ManageBookmarks/sagas"
import {addArticlesBookmark} from "./containers/ManageBookmarks/sagas"
import {removeArticlesBookmark} from "./containers/ManageBookmarks/sagas"

import {addLike} from "./containers/ManageLikes/sagas"
import {removeLike} from "./containers/ManageLikes/sagas"
import {addArticlesLike} from "./containers/ManageLikes/sagas"
import {removeArticlesLike} from "./containers/ManageLikes/sagas"

import {addFeedback} from "./containers/LearningModules/sagas"

export default function* rootSaga(dispatch) {
  yield all([
    takeLatest(StartupTypes.STARTUP, startup, dispatch),
    takeLatest(StartupTypes.STARTUP_ROUTER_LOCATION, startupLocation, dispatch),
    takeLatest(AppTypes.MENU_REQUEST, fetchMenus, dispatch),
    takeLatest(LOCATION_CHANGED, router, dispatch),
    takeLatest("*", forceLogout, dispatch),
    takeLatest(LoginTypes.LOGIN_SUCCESS, fetchMenus, dispatch), // fetch app data after successful login
    takeLatest(AppTypes.SET_LANGUAGE, fetchMenus, dispatch), // fetch menus after changing the language
    takeLatest(LoginTypes.LOGIN_SUCCESS, fetchNotifications, dispatch),
    takeLatest(AppTypes.NOTIFICATIONS_FETCH, fetchNotifications, dispatch),
    takeLatest(AppTypes.SET_LANGUAGE, fetchNotifications, dispatch),
    takeLatest(
      AppTypes.NOTIFICATION_READ_REQUEST,
      readNotificationApp,
      dispatch
    ),
    takeLatest(
      AppTypes.NOTIFICATIONS_READ_ALL_REQUEST,
      readAllNotificationsApp,
      dispatch
    ),
    takeLatest(CommentsTypes.COMMENTS_REQUEST, comments, dispatch),
    takeLatest(CommentsTypes.COMMENTS_ADD, addCommentSaga, dispatch),
    takeLatest(StartupTypes.STARTUP, checkForLoginCookie, dispatch),
    takeLatest(AppTypes.TRACKING_ADD, addTracking, dispatch),
    takeLatest(AppTypes.TRACKING_ADDED, shouldChangeDocumentTitle, dispatch),
    takeLatest(AppTypes.SET_TITLE, changeDocumentTitle, dispatch),
    takeLatest(
      NotificationsTypes.NOTIFICATIONS_READ_REQUEST,
      readNotification,
      dispatch
    ),

    takeLatest(ManageBookmarksTypes.ADD_BOOKMARK, addBookmark, dispatch),
    takeLatest(ManageBookmarksTypes.REMOVE_BOOKMARK, removeBookmark, dispatch),
    takeLatest(
      ManageBookmarksTypes.ADD_ARTICLES_BOOKMARK,
      addArticlesBookmark,
      dispatch
    ),
    takeLatest(
      ManageBookmarksTypes.REMOVE_ARTICLES_BOOKMARK,
      removeArticlesBookmark,
      dispatch
    ),

    takeLatest(ManageLikesTypes.ADD_LIKE, addLike, dispatch),
    takeLatest(ManageLikesTypes.REMOVE_LIKE, removeLike, dispatch),
    takeLatest(ManageLikesTypes.ADD_ARTICLES_LIKE, addArticlesLike, dispatch),
    takeLatest(
      ManageLikesTypes.REMOVE_ARTICLES_LIKE,
      removeArticlesLike,
      dispatch
    ),
    takeLatest(LearningModulesTypes.FEEDBACK_REQUEST, addFeedback, dispatch)
  ])
}



// WEBPACK FOOTER //
// ./src/sagas.js